/**
 * Uniform B2 folder segments for program videos:
 *
 *   Programs/{Program}/Workouts/Phase {n}/Day {n}/{uuid}/{uuid}.ext
 *   Programs/{Program}/Warmup/{uuid}/{uuid}.ext
 *   Programs/{Program}/Intro/{uuid}/{uuid}.ext
 *
 * Phase/day use stable numbers — not editable titles.
 * Server does not prepend STORAGE_PATH_PREFIX for these hierarchical keys.
 */
export function buildProgramPathSegments({
  programName,
  programId,
  section = 'Workouts',
  phaseNumber,
  dayNumber,
}) {
  const name = programName || programId || 'Program';
  const sec = section || 'Workouts';

  let parts;
  if (sec === 'Warmup' || sec === 'Intro') {
    parts = ['Programs', name, sec];
  } else {
    const phase = Math.max(1, parseInt(phaseNumber, 10) || 1);
    const day = Math.max(1, parseInt(dayNumber, 10) || 1);
    parts = ['Programs', name, 'Workouts', `Phase ${phase}`, `Day ${day}`];
  }

  const cleaned = parts
    .map((s) => (s == null ? '' : String(s).trim()))
    .filter(Boolean);

  const deduped = [];
  for (const part of cleaned) {
    const prev = deduped[deduped.length - 1];
    if (prev && prev.toLowerCase() === part.toLowerCase()) continue;
    deduped.push(part);
  }
  return deduped;
}
